'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRoute, faAnglesLeft } from '@fortawesome/pro-solid-svg-icons';
import { PulseIconButton } from 'src/components/PulseUI';

interface RoutesDrawerHeaderProps {
  onCollapse: () => void;
}

const RoutesDrawerHeader: React.FC<RoutesDrawerHeaderProps> = ({ onCollapse }) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-neutral-200 shrink-0">
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-sky-100">
          <Icon icon={faRoute} className="w-4 h-4 text-sky-600" />
        </div>
        <h2 className="text-base font-semibold text-neutral-800">Routes</h2>
      </div>
      <PulseIconButton
        variant="plain"
        color="neutral"
        size="sm"
        icon={faAnglesLeft}
        onClick={onCollapse}
        aria-label="Collapse routes drawer"
        tooltip="Collapse drawer"
        data-testid="routes-drawer-collapse-button"
      />
    </div>
  );
};

export default RoutesDrawerHeader;
